<template>
  <div class="index">
    <Header />
    <NavBar />
    <router-view></router-view>
    <Footer />
  </div>
</template>
<script>
  import Header from './common/header.vue';
  import Footer from './common/footer.vue';
  import NavBar from './common/navBar.vue';
  export default {
    components: {
      Header,
      Footer,
      NavBar
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/index.vue